
const apiConfig = {
    //Local
    //apiUrl: 'https://localhost:7077/api/',
    //Live

    //DEV
   

    // Demo
    apiUrl: 'https://ers-api.solegaze.com/api/',

    apiKey: 'Lieda1002',
};

export default apiConfig;

